export const isSuppressedValue = (value: unknown): boolean =>
  typeof value === 'string' && value.includes('*');
